import { FallbackProvider } from './fallback-provider';
import { DemoProvider } from './demo-provider';
import { LocalDevProvider } from './local-dev-provider';
import { ChannelProvider } from './channel-provider';
import { MobileProvider } from './mobile-provider';
import { PlusProvider } from './plus-provider';
import { AdblockerProvider } from './adblocker-provider';
import { CookiewallProvider } from './cookiewall-provider';
import { AdsProvider } from './ads-provider';

/**
 * A lot of directions we can be taken to determine a provider.
 * All the logic is defined in order or preference.
 */
export function determineWallpaperProvider(config, state) {
  // 0. Something went wrong. Let's show the fallback.
  if (FallbackProvider.test(config, state)) {
    return FallbackProvider;
  }

  // 1. This is used by sales to preview wallpapers accessing /wallpaper/:advert_id
  if (DemoProvider.test(config, state)) {
    return DemoProvider;
  }

  // 2. Local development wallpapers are enabled and set.
  if (LocalDevProvider.test(config, state)) {
    return LocalDevProvider;
  }

  // 3. We're on a channel. Show user's background if available
  if (ChannelProvider.test(config, state)) {
    return ChannelProvider;
  }

  // 4. The user is on Mobile
  if (MobileProvider.test(config, state)) {
    return MobileProvider;
  }

  // 5. We're on a channel with no wallpapers or the user is a Pro user
  if (PlusProvider.test(config, state)) {
    return PlusProvider;
  }

  // 6. Cookie wall! We want to test this new provider: is basically a copy
  // of our editorial wallpaper provider rotating at the same pace the AdsProvider
  // does. It also tracks the impression via Snowplow.
  if (CookiewallProvider.test(config, state)) {
    return CookiewallProvider;
  }

  // 7. Adblocker has been detected.
  if (AdblockerProvider.test(config, state)) {
    return AdblockerProvider;
  }

  // 8. Serve advertisement
  return AdsProvider;
}
